import fetch from '@/api/fetch'

/** 获取当前用户所属企业的角色 */
export const getCurrRoleList = () => fetch.get('/ent/role/curr/list');

/** 获取角色关联人员列表 */
export const getUserListByRoleId = roleId => fetch.get(`/ent/role/user/id/${roleId}`);

/** 删除角色人员 */
export const deleteUserRoleById = userRoleId => fetch.delete(`/ent/role/user/delete/id/${userRoleId}`)

/** 获取所有企业权限 */
export const getEnterprisePowerAll = _ => fetch.get('/ent/role/power/all');


/** 获取所有企业权限分组 */
export const getEnterprisePowerGroupAll = _ => fetch.get('/ent/role/power/all/group');

/** 获取角色拥有的权限id列表 */
export const getPowerIdsByRoleId = roleId => fetch.get(`/ent/role/power/ids/${roleId}`);

/** 保存角色 */
export const saveEnterpriseRole = roleSave => fetch.post(`/ent/role/save`, roleSave);

/** 保存企业角色的有效性 */
export const updateRoleIsEffectiveById = (isEffective, id) => fetch.post(`/ent/role/effective/save/${id}/${isEffective}`)


/** 删除角色 */
export const deleteEnterpriseRole = id => fetch.delete(`/ent/role/delete/id/${id}`);



/** 查询角色可添加的人员 */
export const getRoleCanAddUser = params => fetch.get('/ent/role/add/user/list', { params });

/** 角色添加人员 */
export const roleAddUser = userRole => fetch.post('/ent/role/add/user', userRole);

/** 角色删除人员 */
export const roleDeleteUser = userRoleId => fetch.delete(`/ent/role/delete/user/id/${userRoleId}`);


/** 查询主管理员可转让的人员 */
export const getTransferUserList = params => fetch.get('/ent/role/transfer/user/list', { params });


/** 转让企业超管角色（主管理员） */
export const transferSuperRole = userId => fetch.post(`/ent/role/transfer/super/user/${userId}`);